import { VMWareSizeAssessmentServer } from '@amzn/awscat-portfolio-assessment-types';

import { constants } from '../../../../common/Localization';
import AWSCATTable from '../../../../common/table/Table-index';
import { ColumnDefinition, ColumnTypes } from '../../../../common/table/types';

type Props = {
    vmwareSizeAssessmentServers: VMWareSizeAssessmentServer[];
}

function VMware({ vmwareSizeAssessmentServers }: Props): JSX.Element {

    const columnDefinition: ColumnDefinition<VMWareSizeAssessmentServer>[] = [
        { header: constants.SERVER_ID, type: ColumnTypes.TEXT, id: 'id', cell: item => item.id, text: constants.SERVER_ID },
        { header: constants.CLUSTER_NAME, type: ColumnTypes.TEXT, id: 'clusterName', cell: item => item.clusterName, text: constants.CLUSTER_NAME },
    ];
    return (
        <AWSCATTable
            resourceName={constants.VMWARE_CLOUD_RECOMMENDATIONS_DETAIL}
            columnDefinitions={columnDefinition}
            items={vmwareSizeAssessmentServers}
            autoGenerateVisibleContent
            enableAutoSorting
            resizeable
            useDefaultDownload
        />
    );
}

export default VMware;
